import React from 'react';
import styled, { css } from 'styled-components';
import { minBp } from 'src/lib/theme';

export const Section = styled.section`
  margin-bottom: 20px;
`;

export const Header = styled.div`
  border-bottom: 1px solid #a7a9ac;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 5px;
  margin-bottom: 16px;
`;

export const RemoveCTA = styled.button`
  display: flex;
  align-items: center;
  background-color: #2a2a2a;
  min-width: 70px;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  border: none;
  height: 26px;
  cursor: pointer;

  svg {
    padding-right: 3px;
    path {
      fill: #fff;
    }
  }
`;

export const HeaderTitle = styled.span`
  color: #000;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.dinDemi};

  @media ${minBp('tablet')} {
    line-height: 18px;
    font-size: 16px;
  }
`;

export const ItemsSummary = styled.div`
  margin-top: 12px;
  margin-bottom: 29px;
`;
